import Highcharts from 'highcharts';
import highchartsExportingInit from 'highcharts/modules/exporting';
import highchartsExportDataInit from 'highcharts/modules/export-data';

highchartsExportingInit(Highcharts);
highchartsExportDataInit(Highcharts);

const stationCounts = document.getElementById('station-counts');

// Chart variables of full datasets for when no date range is selected
const level2AvailableDataset = JSON.parse(stationCounts.getAttribute('data-l2-available'));
const dcAvailableDataset = JSON.parse(stationCounts.getAttribute('data-dc-available'));
const l2TempUnavailableDataset = JSON.parse(stationCounts.getAttribute('data-l2-temporarily-unavailable'));
const dcTempUnavailableDataset = JSON.parse(stationCounts.getAttribute('data-dc-temporarily-unavailable'));

let chartStartDate = Date.UTC(2021, 0, 1); // defaults to January 1, 2021
const startMonth = new URLSearchParams(window.location.search).get('start_month');

if (startMonth) {
  chartStartDate = Date.UTC(startMonth.slice(0, 4), startMonth.slice(5, 7) - 1, 1);
}

// Submit forms on filter changes
const filters = document.querySelectorAll('.stations-growth-filter');

filters.forEach((filter) => {
  filter.addEventListener('change', function filterChange() {
    this.form.submit();
  });
});

// Create the chart
Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
});
const chart = Highcharts.chart('container', {
  credits: {
    enabled: true,
  },
  chart: {
    type: 'area',
    height: '600',
  },
  title: {
    text: 'U.S. Public Electric Vehicle Charging Ports by Month',
  },
  yAxis: {
    title: {
      text: 'Charging Ports',
    },
  },
  xAxis: {
    type: 'datetime',
  },
  tooltip: {
    shared: true,
    xDateFormat: '%B %Y',
    headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>',
  },
  plotOptions: {
    area: {
      stacking: 'overlap',
    },
    series: {
      pointStart: chartStartDate,
      pointIntervalUnit: 'month',
      marker: {
        enabled: false,
      },
      events: {
        legendItemClick() {
          return false;
        },
      },
    },
  },
  series: [],
  legend: {
    itemStyle: {
      cursor: 'default',
    },
  },
});

// Handle checkbox changes
// charger type fields:
const level2Box = document.getElementById('level_2');
const dcBox = document.getElementById('dc_fast');

// station status fields:
const available = document.getElementById('available');
const tempUnavailable = document.getElementById('temporarily_unavailable');

if (available.checked && level2Box.checked) {
  chart.addSeries({
    id: 'available_l2',
    name: 'Available – Level 2',
    color: '#00B5EF',
    data: level2AvailableDataset,
  });
}

if (available.checked && dcBox.checked) {
  chart.addSeries({
    id: 'available_dc_fast',
    name: 'Available – DC Fast',
    color: '#005A7C',
    data: dcAvailableDataset,
  });
}

if (tempUnavailable.checked && level2Box.checked) {
  chart.addSeries({
    id: 'temp_unavailable_l2',
    name: 'Temporarily Unavailable – Level 2',
    color: '#9D9D9D',
    data: l2TempUnavailableDataset,
  });
}

if (tempUnavailable.checked && dcBox.checked) {
  chart.addSeries({
    id: 'temp_unavailable_dc_fast',
    name: 'Temporarily Unavailable – DC Fast',
    color: '#666666',
    data: dcTempUnavailableDataset,
  });
}
